function getHtmlElement(): HTMLHtmlElement | undefined | null {
  const html = document.querySelector('html');
  return html instanceof HTMLHtmlElement ? html : null;
}

function getBodyElement(): HTMLBodyElement | undefined | null {
  const body = document.querySelector('body');
  return body instanceof HTMLBodyElement ? body : null;
}

function getBodyFirstChildElement(): HTMLDivElement | undefined | null {
  const body = getBodyElement();
  return body && body.firstElementChild instanceof HTMLDivElement ? body.firstElementChild : null;
}

export function resetBodyScroll(): void {
  if (typeof document === 'undefined') {
    return;
  }

  const html = getHtmlElement();
  const bodyFirstChild = getBodyFirstChildElement();

  // reset scrollbar margin
  if (bodyFirstChild) {
    bodyFirstChild.style.marginRight = '0';
  }

  // allow body scrolling
  if (html) {
    html.style.overflow = 'auto';
  }
}

export function manageBodyScroll(): void {
  if (typeof document === 'undefined') {
    return;
  }

  const visibleModals: NodeListOf<HTMLElement> = document.querySelectorAll('.modal-dialog:not(.modal-dialog--hidden),.modal-opener:not(.modal-opener--hidden)');

  const html = getHtmlElement();
  const bodyFirstChild = getBodyFirstChildElement();
  const hasMargin = bodyFirstChild && bodyFirstChild.style.marginRight !== '' && bodyFirstChild.style.marginRight !== '0px';

  if (visibleModals.length > 0) {
    // set scrollbar margin before hiding scrollbar to avoid screen jumping when closing modal
    if (!hasMargin && bodyFirstChild && html) {
      bodyFirstChild.style.marginRight = `${window.innerWidth - html.clientWidth}px`;
    }

    // block body scrolling
    if (html) {
      html.style.overflow = 'hidden';
    }
  } else {
    resetBodyScroll();
  }
}
